/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingstepslabel2Inputs */

const en_onboardingstepslabel2 = /** @type {(inputs: Onboardingstepslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup`)
};

const de_onboardingstepslabel2 = /** @type {(inputs: Onboardingstepslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einrichtung`)
};

/**
* | output |
* | --- |
* | "Setup" |
*
* @param {Onboardingstepslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingstepslabel2 = /** @type {((inputs?: Onboardingstepslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingstepslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingstepslabel2(inputs)
	return de_onboardingstepslabel2(inputs)
});
export { onboardingstepslabel2 as "onboardingStepsLabel" }